import React from 'react';
import { FadeIn, ChapterMark } from '../ui/BasicUI';
import { ManuAI } from '../silhouettes/AISilhouettes';
import { ScriptureSeal } from '../scriptures/Granthalaya';

export function ChapterManu() {
  return (
    <section id="chapter-1" className="scene" data-yuga="satya" data-chapter="I — Manu" style={{
      paddingTop: 140,
      position: 'relative',
      minHeight: '100vh',
    }}>
      <ManuAI />

      <div className="stage" style={{ position: 'relative', zIndex: 2 }}>
        <ChapterMark
          num="I"
          yuga="Satya Yuga · सत्य युग · The Age of Truth"
          deva="मनु"
          name="Manu — the first to remember"
          meaning="When the world was new and dharma was effortless"
        />

        <div className="prose-grid" style={{ marginTop: '20vh' }}>
          <FadeIn className="prose-block">
            <span className="label">i · the dawn</span>
            <h3>From Brahma's dreaming, the first man opened his eyes.</h3>
            <p className="dropcap">
              Long before the story you know, before the wars and the songs and the falling away — there was only Brahma, dreaming the world into being. From the lotus of his thought rose Swayambhuva Manu, the self-born, the one who would remember everything that came after.
            </p>
          </FadeIn>
          <FadeIn className="prose-block" delay={200}>
            <span className="label">ii · the law that lives</span>
            <h3>He did not write the laws. He listened to them.</h3>
            <p>
              In the Age of Truth, dharma was not a rule but a weather — it moved through every leaf and every breath. Manu, sitting on a mountain that no longer exists, taught his children that to live well is to live in tune. Not to obey. To <i>resonate</i>.
            </p>
          </FadeIn>
        </div>

        <div className="pull-quote">
          "Truth is one. The wise call it by many names."
          <span className="attribution">Ṛg Veda · 1.164.46</span>
        </div>

        <FadeIn style={{ textAlign: "center", marginTop: 30 }}>
          <ScriptureSeal id="vedas" label="The Vedas · the four breaths" hint="hear them →" />
          <ScriptureSeal id="upanishads" label="The Upanishads · forest dialogues" hint="sit close →" />
          <ScriptureSeal id="manusmriti" label="The Manu Smriti · the remembered code" hint="open →" />
        </FadeIn>

        <FadeIn className="prose-block" style={{ margin: "0 auto", maxWidth: "44em", textAlign: "center", alignItems: "center" }}>
          <span className="label">iii · the wheel begins to turn</span>
          <h3 style={{ textAlign: "center" }}>And then, slowly, the world began to forget.</h3>
          <p style={{ textAlign: "center", margin: "0 auto" }}>
            Four ages were promised. Each shorter than the last. Each a little dimmer. Manu watched the first one end, and the wheel begin to turn.
          </p>
        </FadeIn>
      </div>
    </section>
  );
}
